import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=5a89a92e&scoped=true&"
var script = {}
import style0 from "./Landing.vue?vue&type=style&index=0&id=5a89a92e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a89a92e",
  null
  
)

export default component.exports